import { CSSProperties, useMemo } from 'react'
import { IOption } from '@/types/global.ts'
import usePassportSchema from '@/pages/MDM/hooks/usePassprotSchema.ts'
import { IPassportGroup, IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  value: IPassportGroup['id']
  name: string
  onChange: (val: IPassportGroup['id'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
  passportSchemaId: IPassportSchema['id']
}

const PassportGroupDropdown = (props: IProps) => {
  const groups = usePassportSchema(props.passportSchemaId).groups

  const groupOption: IOption<IPassportGroup['id']>[] = useMemo(() => {
    return groups.map((b) => ({ title: b.name, value: b.id }))
  }, [groups])

  return (
    <DropdownInput
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      onSelect={props.onChange}
      options={groupOption as any}
      selectedOption={props.value as any}
      title={props.title || 'Выберите группу'}
    />
  )
}

export default PassportGroupDropdown
